import { render, staticRenderFns } from "./OrganizationStaffInfo.vue?vue&type=template&id=769daff6&scoped=true&"
import script from "./OrganizationStaffInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationStaffInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769daff6",
  null
  
)

export default component.exports